module.exports = __webpack_public_path__ + "static/img/Mosaic-Selected.036a09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Mosaic-Selected.png
// module id = 740
// module chunks = 0